import React, { Component } from "react";
import Search from "../../../../common/components/search-text/search-text";
import Button from "../../../button-classic/button-classic";
import { connect } from "react-redux";
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import { withRouter } from "react-router-dom";
import AddFocusMaster from "./add-focus-master";
import ACTIONS from "../../../../common/action_constant";
import MASTER_TYPE_CONFIG from "../../../../common/masterTypeConfig";

class FocusMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      offset: 0,
      limit: 10,
      isOpen: false,
      editData: null,
      focusData: [],
      plantOptions: [],
      stateOptions: [],
      countyOptions: [],
    };
  }

  componentDidMount() {
    this.getFocusMasterData();
    this.getBranchDropdownData();
    this.getStateDropdownData();
    this.getcountyDropdownData();
  }
  getFocusMasterData = () => {
    const { dispatch, match } = this.props;
    const { search, offset, limit } = this.state;
    let param = `?companyId=${match.params.id}&limit=${limit}&offset=${offset}`;
    if (search) param += `&search=${search}`;

    dispatch({
      type: ACTIONS.PLANTS.GET_FOCUS_LIST_MASTER,
      param,
      onSuccess: (res) => {
      this.setState({ focusData: res || [] });
      },
    });
  };
  getBranchDropdownData = () => {
    const { dispatch, match } = this.props;
    const param = `?companyId=${match.params.id}&companyType=1`;
    dispatch({
      type: ACTIONS.PLANTS.GET_FOCUS_BRANCH_LIST_MASTER,
      param,
      onSuccess: (res) => {
        const options =
          res?.list?.map((item) => ({
            value: item.branch_code,
            label: item.branch_code,
          })) || [];
        this.setState({ plantOptions: options });
      },
    });
  };

  getStateDropdownData = () => {
    const { dispatch, match } = this.props;
    const data = { company_id: match.params.id };

    dispatch({
      type: ACTIONS.MASTER.LOCATION_NETWORK.GET_STATE,
      data,
      onSuccess: (res) => {
        const options =
          res?.map((item) => ({
            value: item.code,
            label: item.name,
          })) || [];
        this.setState({ stateOptions: options });
      },
    });
  };

  getcountyDropdownData = () => {
    const { dispatch, match } = this.props;
    const param = `?companyId=${match.params.id}`;

    dispatch({
      type: ACTIONS.PLANTS.GET_COUNTY_DESCRIPTION_MASTER,
      param,
      onSuccess: (res) => {
        const options =
          res?.map((item) => ({
            value: item.county_code,
            label: item.county_description,
          })) || [];
        this.setState({ countyOptions: options });
      },
    });
  };

  toggleAdd = () => {
    this.setState({ isOpen: !this.state.isOpen, editData: null });
  };

  editFocusMaster = (data) => {
    this.setState({
      isOpen: true,
      editData: data,
    });
  };

  deleteFocusMaster = (item) => {
    const { dispatch, match } = this.props;

    dispatch({
      type: ACTIONS.PLANTS.DELETE_FOCUS_PLANTS_MASTER,
      data: {
        focus_plant_id: item.focus_plant_id,
        company_id: match.params.id,
      },
      onSuccess: () => {
        this.getFocusMasterData();
      },
    });
  };

  downloadFocusPlantsTemplate = () => {
    const { dispatch, match } = this.props;
    const params = `companyId=${match.params.id}`;

    dispatch({
      type: ACTIONS.PLANTS.DOWNLOAD_FOCUS_PLANTS_TEMPLATE,
      params,
      onSuccess: (presignedUrlData) => {
        if (presignedUrlData?.url) {
          window.location.href = presignedUrlData.url;
        }
      },
    });
  };

  uploadFocusPlantsMaster = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const { dispatch, match } = this.props;
    const companyId = match?.params?.id;
    if (!companyId) return;

    const formData = new FormData();
    formData.append("file", file);

    dispatch({
      type: ACTIONS.PLANTS.UPLOAD_FOCUS_PLANTS_MASTER_DATA,
      data: formData,
      queryString: `companyId=${companyId}`,
      onSuccess: () => {
        this.getFocusMasterData();
      },
    });

    e.target.value = "";
  };

  next = () => {
    this.setState(
      (prevState) => ({
        offset: prevState.offset + prevState.limit,
      }),
      this.getFocusMasterData
    );
  };

  previous = () => {
    if (this.state.offset >= this.state.limit) {
      this.setState(
        (prevState) => ({
          offset: prevState.offset - prevState.limit,
        }),
        this.getFocusMasterData
      );
    }
  };

  handleOnClickForAuditBtn = () => {
    const { history, match } = this.props;
    const companyId = match.params.id;
    const masterType = MASTER_TYPE_CONFIG.FOCUS_MASTER;
    const navUrl = `/auditScreen/${companyId}/${masterType}`;
    history.push(navUrl);
  };

  render() {
    const { focusData } = this.state;

    return (
      <div className="location-network">
        <div style={{ paddingBottom: "15px" }}>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <Search
              id="search"
              value={this.state.search}
              placeholder="Search..."
              changeHandler={(value) => {
                this.setState(
                  { search: value, offset: 0 },
                  this.getFocusMasterData
                );
              }}
              canClear={this.state.search !== ""}
              handleClearFilter={() =>
                this.setState(
                  { search: "", offset: 0 },
                  this.getFocusMasterData
                )
              }
            />

            <Button value="+ Add Focus Configuration" click={this.toggleAdd} />
            <button className="button-classic" onClick={this.handleOnClickForAuditBtn}>Audit</button>

            <button
              className="button-classic"
              onClick={this.downloadFocusPlantsTemplate}
            >
              Download Template
            </button>

            <label
              className="button-classic"
              style={{
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Upload
              <input
                type="file"
                hidden
                onChange={this.uploadFocusPlantsMaster}
              />
            </label>
          </div>
        </div>

        <table className="custom-sap-table">
          <thead>
            <tr>
              <th>Plant Code</th>
              <th>Region</th>
              <th>County Description</th>
              <th>County Code</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {focusData.length > 0 ? (
              focusData.map((item, index) => (
                <tr key={index}>
                  <td>{item.plant_code}</td>
                  <td>{item.region_name}</td>
                  <td>{item.county_description}</td>
                  <td>{item.county_code}</td>
                  <td>
                    <div
                      className="action-icon"
                      style={{ backgroundImage: `url(${Edit})` }}
                      onClick={() => this.editFocusMaster(item)}
                    />
                    <div
                      className="action-icon"
                      style={{ backgroundImage: `url(${Delete})` }}
                      onClick={() => this.deleteFocusMaster(item)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>


        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={this.next} />
          </div>
          <div className="pre">
            <Button value="Previous" click={this.previous} />
          </div>
        </div>

        {this.state.isOpen && (
          <AddFocusMaster
            toggleAdd={this.toggleAdd}
            editData={this.state.editData}
            companyId={this.props.match.params.id}
            dispatch={this.props.dispatch}
            refreshData={this.getFocusMasterData}
            plantOptions={this.state.plantOptions}
            regionOptions={this.state.stateOptions}
            countyOptions={this.state.countyOptions}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  companyId: state.common?.companyId || "",
});

export default connect(mapStateToProps)(withRouter(FocusMaster));
